import { filterObjectValues } from 'helpers/filter'

import { IStatistic } from 'models/statistic'

import { downloadFileHandler } from 'shared/libs/fileResponseHandler'

import api from '../api'
import {
  GetInstantCardsListResponse,
  GetInstantCardsParams,
  InstantCardObject,
} from './types'

export const instantCardApi = api.injectEndpoints({
  endpoints: build => ({
    getInstantCards: build.query<
      GetInstantCardsListResponse,
      GetInstantCardsParams
    >({
      query: params => ({
        url: `/web/kartomat/instant_card/`,
        params: filterObjectValues(params),
      }),
      keepUnusedDataFor: 60 * 5,
    }),
    getInstantCardById: build.query<InstantCardObject, InstantCardObject['id']>(
      {
        query: id => ({
          url: `/web/kartomat/instant_card/${id}/`,
        }),
      },
    ),
    instantCardStatistics: build.query<
      Array<IStatistic>,
      GetInstantCardsParams
    >({
      query: params => ({
        url: `/web/kartomat/instant_card/statistics/`,
        params: filterObjectValues(params),
      }),
      keepUnusedDataFor: 60 * 5,
    }),
    downloadInstantCardExcel: build.mutation<void, GetInstantCardsParams>({
      query: params => ({
        url: `/web/kartomat/instant_card/excel/`,
        params: filterObjectValues(params),
        responseHandler: downloadFileHandler,
        cache: 'no-cache',
      }),
    }),
  }),
})
